module.exports = "<invoices-page></invoices-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/invoices.html
// module id = 1693
// module chunks = 0